import { ILectur } from 'constants/types/common.types'
import { formatMoscowDate } from 'utils/formatDate'

const formatLecturs = (lecturs: ILectur[]) => {
  const preparedLecturs = lecturs?.length > 3 ? lecturs.slice(0, 3) : lecturs
  return preparedLecturs
    .map((lectur) => {
      let result = ''
      if (lectur.lastName) result += lectur.lastName
      if (lectur.firstName) result += ` ${lectur.firstName.substring(0, 1)}.`
      if (lectur.secondName) result += ` ${lectur.secondName.substring(0, 1)}.`
      return result
    })
    .join(', ')
}

const formatDate = (date: Date) => {
  const moscowDate = formatMoscowDate(date as Date)
  if (!moscowDate) return ''
  return moscowDate.date + ' ' + moscowDate.monthName + ' ' + moscowDate.time
}

export { formatLecturs, formatDate }
